if (!customElements.get('card-inline-add')) {
customElements.define(
'card-inline-add',
class CardInlineAdd extends HTMLElement {
connectedCallback() {
if (this.dataset.initialized === 'true') return;
this.dataset.initialized = 'true';

this.variants = this.parseVariants();
this.selects = Array.from(this.querySelectorAll('[data-option-index]'));
this.idInput = this.querySelector('[data-variant-id-input]');
this.submitButton = this.querySelector('[data-inline-submit]');
this.submitText = this.querySelector('[data-inline-submit-text]');
this.qtyInput = this.querySelector('[data-qty-input]');
this.cardWrapper = this.closest('.card-wrapper');
this.priceElement = this.cardWrapper ? this.cardWrapper.querySelector('.price') : null;

this.strings = {
addToCart: this.dataset.stringAddToCart || 'Add to cart',
soldOut: this.dataset.stringSoldOut || 'Sold out',
unavailable: this.dataset.stringUnavailable || 'Unavailable',
};

this.selects.forEach((select) => {
select.addEventListener('change', this.onOptionChange.bind(this));
});

this.querySelectorAll('[data-qty-change]').forEach((button) => {
button.addEventListener('click', this.onQuantityButton.bind(this));
});

if (this.qtyInput) {
this.qtyInput.addEventListener('change', this.clampQuantity.bind(this));
}

if (this.selects.length > 0) this.onOptionChange();
}

parseVariants() {
const dataElement = this.querySelector('[data-inline-variants]');
if (!dataElement) return [];
try {
return JSON.parse(dataElement.textContent);
} catch (error) {
console.error('card-inline-add: unable to parse variant data', error);
return [];
}
}

get selectedOptions() {
return this.selects
.slice()
.sort((a, b) => Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex))
.map((select) => select.value);
}

onOptionChange() {
const selected = this.selectedOptions;
const variant = this.variants.find(
(candidate) =>
Array.isArray(candidate.options) &&
candidate.options.length === selected.length &&
candidate.options.every((value, index) => value === selected[index])
);
this.updateVariant(variant);
}

updateVariant(variant) {
if (!variant) {
if (this.idInput) this.idInput.value = '';
this.setButtonState(false, this.strings.unavailable);
return;
}

if (this.idInput) this.idInput.value = variant.id;
this.applyQuantityRules(variant);
this.updatePrice(variant);
this.setButtonState(variant.available, variant.available ? this.strings.addToCart : this.strings.soldOut);
}

setButtonState(enabled, label) {
if (!this.submitButton) return;
this.submitButton.disabled = !enabled;
if (this.submitText) this.submitText.textContent = label;
}

applyQuantityRules(variant) {
if (!this.qtyInput) return;
const min = variant.qty_min > 0 ? variant.qty_min : 1;
const step = variant.qty_step > 0 ? variant.qty_step : 1;
this.qtyInput.min = min;
this.qtyInput.step = step;
if (variant.qty_max > 0) {
this.qtyInput.max = variant.qty_max;
} else {
this.qtyInput.removeAttribute('max');
}
this.clampQuantity();
}

clampQuantity() {
if (!this.qtyInput) return;
const min = parseInt(this.qtyInput.min, 10) || 1;
const step = parseInt(this.qtyInput.step, 10) || 1;
const max = this.qtyInput.max ? parseInt(this.qtyInput.max, 10) : Infinity;
let value = parseInt(this.qtyInput.value, 10);
if (isNaN(value) || value < min) value = min;
value = min + Math.round((value - min) / step) * step;
if (value > max) value = max - ((max - min) % step);
if (value < min) value = min;
this.qtyInput.value = value;
}

onQuantityButton(event) {
if (!this.qtyInput) return;
const direction = event.currentTarget.dataset.qtyChange;
const step = parseInt(this.qtyInput.step, 10) || 1;
const current = parseInt(this.qtyInput.value, 10) || parseInt(this.qtyInput.min, 10) || 1;
this.qtyInput.value = direction === 'plus' ? current + step : current - step;
this.clampQuantity();
}

updatePrice(variant) {
if (!this.priceElement) return;
const onSale = Number(variant.compare_at_price_cents) > Number(variant.price_cents);
const regular = this.priceElement.querySelector('.price__regular .price-item--regular');
const saleCompare = this.priceElement.querySelector('.price__sale s.price-item--regular');
const sale = this.priceElement.querySelector('.price__sale .price-item--sale');

if (regular) regular.textContent = variant.price;
if (sale) sale.textContent = variant.price;
if (saleCompare) saleCompare.textContent = variant.compare_at_price || '';

this.priceElement.classList.toggle('price--on-sale', onSale);
this.priceElement.classList.toggle('price--sold-out', !variant.available);
}
}
);
}